import LoadingSkeletonImageDynamic from "../../../components/LoadingSkeletonImageDynamic";
import TypingIndicator from "../../../components/TypingIndicator";
import {
  setViewImage,
  toggleProfileView,
  updateViewState,
} from "../../../store/Slices/ViewManagerSlice";
import { formatLastSeen } from "../../../utils/formatUTCtoLocalDate";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import { useEffect, useState } from "react";
import TextTranslate from "../../../utils/TextTranslate";
import { IoChevronBack } from "react-icons/io5";
import { resetCurrentConversation } from "../../../store/Slices/CurrentConversationSlice";
import ShowSavedName from "../../../components/ShowSavedName";
import { useConversationMembers } from "../../../store/api/useConversationMembers";

export default function Profile() {
  const dispatch = useAppDispatch();
  const { translate, hour12 } = useTimeFormatOptions();
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );
  const ContactList = useAppSelector((state) => state.ContactList);
  const [showLastSeen, setshowLastSeen] = useState(false);
  const OnlineUserList = useAppSelector((state) => state.OnlineUserList);
  const TypingUserList = useAppSelector((state) => state.TypingUserList);
  const userData = useAppSelector((state) => state.userData);
  const { data: conversationMembers } = useConversationMembers();
  const isTypingHere = TypingUserList.typingUserList.some(
    (typing) => typing.chat_id == currentConversationData.chat_id,
  );

  useEffect(() => {
    setTimeout(() => {
      setshowLastSeen(true);
    }, 3000);
  }, []);

  return (
    <div className="flex items-center sm:gap-2">
      {/* Back button ===========================================================*/}
      <IoChevronBack
        onClick={() => {
          dispatch(
            updateViewState({
              show_chats_sidebar: true,
            }),
          );
          dispatch(resetCurrentConversation());
        }}
        className="mr-2 flex w-fit cursor-pointer text-2xl lg:hidden"
      />

      <div
        onClick={() => {
          dispatch(
            setViewImage({
              show_image: true,
              image_src: [
                (currentConversationData.chat_type == "group"
                  ? currentConversationData.group_icon
                  : currentConversationData.profile_pic) ?? "",
              ],
            }),
          );
        }}
        className="mr-3 h-10 w-10 max-h-10 max-w-10 shrink-0 cursor-pointer overflow-hidden rounded-full 2xl:h-12 2xl:w-12 2xl:max-h-12 2xl:max-w-12"
      >
        <LoadingSkeletonImageDynamic
          radius=""
          className="h-full w-full max-h-full max-w-full object-cover"
          image_height=""
          image_url={
            (currentConversationData.chat_type == "group"
              ? currentConversationData.group_icon
              : currentConversationData.profile_pic) ?? ""
          }
          blur_hash={
            currentConversationData.blur_hash ||
            currentConversationData.blurHash
          }
          image_width=""
        />
      </div>
      <div className="flex min-w-0 flex-col justify-center leading-tight">
        <div
          onClick={() => {
            dispatch(toggleProfileView(true));
          }}
          className="cursor-pointer truncate text-sm font-medium capitalize text-darkText sm:text-base"
        >
          {currentConversationData.chat_type == "group" ? (
            currentConversationData.group_name
          ) : (
            <ShowSavedName
              user_id={currentConversationData.user_id!.toString()}
              name={currentConversationData.full_name}
            />
          )}
        </div>

        {/* Fixed subtitle row so Typing / Online swap does not shift the name */}
        <div className="mt-0.5 flex h-[16px] items-center overflow-hidden text-xs leading-none text-lightText sm:text-sm">
          {currentConversationData.chat_type == "group" ? (
            isTypingHere ? (
              <TypingIndicator />
            ) : (
              <div className="line-clamp-1">
                {(() => {
                  const members = conversationMembers?.data?.Records || [];
                  const names = members.map(
                    (user) =>
                      user.user_id == userData.user_id
                        ? "You"
                        : ContactList?.data?.find(
                            (e) =>
                              e?.user_id.toString() ==
                              user.User.user_id.toString(),
                          )?.name ?? user.User.full_name,
                  );
                  const maxVisible = 3;
                  const visibleNames = names.slice(0, maxVisible).join(", ");
                  const remainingCount = names.length - maxVisible;

                  return (
                    <>
                      {visibleNames}
                      {remainingCount > 0 && (
                        <span
                          onClick={() => {
                            dispatch(toggleProfileView(true));
                          }}
                          className="cursor-pointer text-darkText"
                        >
                          {` +${remainingCount} ${translate("more")}`}
                        </span>
                      )}
                    </>
                  );
                })()}
              </div>
            )
          ) : isTypingHere ? (
            <TypingIndicator />
          ) : OnlineUserList.onlineUsers.find(
              (user) => user.user_id == currentConversationData.user_id,
            ) ? (
            <div className="flex items-center gap-1.5">
              <img
                className="h-3 w-3 shrink-0"
                src="/Home/Online_Green_dot.png"
                alt=""
              />
              <span className="leading-none">
                <TextTranslate text="Online" />
              </span>
            </div>
          ) : showLastSeen ? (
            <span className="truncate leading-none">
              {formatLastSeen(currentConversationData.updatedAt, {
                translate,
                hour12,
              })}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
